export default "/images/2a02a21883586063138ce7a2ae0d70e7.avif";